import { Tab } from "@headlessui/react";
import VoyageCard from "components/VoyageCard/VoyageCard";
import VoyageurRating from "components/VoyageurRating/VoyageurRating";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import React, { FC, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import SocialsList from "./SocialsList";
import { Helmet } from "react-helmet";
import { compteService } from '_services/compte.service'
import { VoyageDataType } from "data/types";
import { Tooltip }  from "react-tooltip";
import 'react-tooltip/dist/react-tooltip.css'
import Axios from '../../_services/caller.service';
import { useTranslation } from 'react-i18next';

export interface VoyageurPageProps {
  className?: string;
}

const VoyageurPage: FC<VoyageurPageProps> = ({ className = "" }) => {
  const { t } = useTranslation();

  const [voyageurData, setVoyageurData] = useState<any>(null);
  const { id } = useParams<{ id: string }>();
  const [imageAvatar, setImageAvatar] = useState("");
  const [nbLikesVoyageur, setNbLikesVoyageur] = useState(0);
  const [viewMode, setViewMode] = useState<'timeline' | 'cards'>('timeline');
  

  const navigate = useNavigate();

  const calculateTotalLikes = (resultData: any) => {
    if (resultData && resultData.voyages) {
      return resultData.voyages.reduce((totalLikes :number, voyage: VoyageDataType) => {
        return totalLikes + (voyage.nb_likes || 0);
      }, 0);
    }
    return 0;
  };

  const handleShareProfile = async () => {
  const profileUrl = window.location.href;

  try {
    if (navigator.share) {
     await navigator.share({
        title: `Profil de ${voyageurData?.username || 'voyageur'}`,
        text: ``,
        url: profileUrl,
      });
    } else {
      await navigator.clipboard.writeText(profileUrl);
      alert("Lien du profil copié !");
    }
  } catch (error) {
    // L'utilisateur peut simplement avoir fermé la fenêtre de partage
    console.log("Partage annulé");
  }
};

  useEffect(() => {
    // Appeler l'API pour obtenir les informations sur le voyageur
    compteService.getUser(id)
      .then((response) => {
        // Mettre à jour l'état avec les données reçues de l'API
        //setVoyageurData(response.data);

        console.log("response",response);
        if(response.data.groupedResults.length === 0)
        {
         navigate('/');
        }
        else
        {
         setVoyageurData(response.data.groupedResults[0]);
 
          setNbLikesVoyageur(calculateTotalLikes(response.data.groupedResults[0]));


        }
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données du voyageur:", error);
        navigate('/');
      });
  }, []);

  
  useEffect(() => {
   
    let imageURL: string | undefined;
  
     if(voyageurData?.avatar && voyageurData?.avatar !== "")
     {

       Axios.get(voyageurData?.avatar, { responseType: 'blob' })
       .then((response) => {
         const blob = new Blob([response.data], { type: 'image/jpeg' });
         imageURL = URL.createObjectURL(blob);
         setImageAvatar(imageURL);
       })
       .catch((error) => console.error('Erreur lors du chargement de l\'image', error));
     }
  
     return () => {
       if (imageURL) {
         URL.revokeObjectURL(imageURL); // Révoquez l'URL seulement lorsque le composant est démonté
       }
     };
     
   }, [voyageurData?.avatar]);

   const handleMajLike = () => {
    setNbLikesVoyageur((prevNbLikes) => prevNbLikes + 1);
   }

   const handleMajDislike = () => {
    setNbLikesVoyageur((prevNbLikes) => prevNbLikes - 1);
  }


  const renderSidebar = () => {
    return (
      <div className=" [ nc-box-has-hover ] [ nc-dark-box-bg-has-hover ] w-full flex flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8 pt-2">
       <Avatar
          //hasChecked
          //hasCheckedClass="w-6 h-6 -top-0.5 right-2"
          sizeClass="w-32 h-32"
          imgUrl={imageAvatar || ''}
      />

        {/* ---- */}
        <div className="space-y-3 text-center flex flex-col items-center">
          <h2 className="text-xl font-semibold dark:text-neutral-300">{ voyageurData?.username }</h2>
          <span 
          data-tooltip-id="myTooltip"
          data-tooltip-content={t('totalLikes')}
          data-tooltip-place="bottom"
          >
            <VoyageurRating className="!text-base dark:text-neutral-300" totalLikes={nbLikesVoyageur} />
          </span>
        </div>

        <Tooltip id="myTooltip" />

        {/* ---- */}
        <p className="text-neutral-500 dark:text-neutral-400">
        { voyageurData?.presentation || ''}
        </p>

        {/* ---- */}
        <SocialsList
          className="!space-x-3"
          itemClass="flex items-center justify-center w-9 h-9 rounded-full bg-neutral-100 dark:bg-neutral-800 text-xl"
          instagram={voyageurData?.instagramUser || ''}
          facebook={voyageurData?.facebookUser || ''}
          youtube={voyageurData?.youtubeUser || ''}
          twitter={voyageurData?.twitterUser || ''}
          site={voyageurData?.siteUser || ''}
        />

        {/* ---- */}
        <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>

        {/* ---- */}
        <div className="space-y-5">

  {/* Date d'inscription */}
  <div className="flex items-center space-x-4">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-6 w-6 text-neutral-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>

    <span className="text-neutral-6000 dark:text-neutral-300">
      {t('inscritEn')} {voyageurData?.dateUser || ''}
    </span>
  </div>


  {/* Partager le profil */}
  <button
    type="button"
    onClick={handleShareProfile}
    className="
      flex
      items-center
      justify-center
      gap-2
      rounded-full
      px-5
      py-2.5
      text-sm
      font-medium
      text-purple-600
      bg-purple-50
      hover:bg-purple-100
      transition-colors
      dark:bg-purple-900/20
      dark:text-purple-400
      dark:hover:bg-purple-900/30
    "
  >
     <i className={`las la-share-square text-lg`}></i>&nbsp;{t('partagerProfil')}

  </button>

</div>
      </div>
    );
  };

const renderSection1 = () => {
  const voyages = voyageurData?.voyages || [];

  /*
   * Retourne l'année du voyage à partir de date_deb_formate.
   * Exemple : "10/07/2026" -> "2026"
   */
/*
 * Retourne l'année du voyage.
 */
const getVoyageYear = (
  voyage?: VoyageDataType
): string | null => {

  if (!voyage || !voyage.date_deb_formate) {
    return null;
  }

  const parts = voyage.date_deb_formate.split('/');

  if (parts.length === 3) {
    return parts[2];
  }

  return null;
};


/*
 * Indique si le voyage est le premier voyage de son année.
 */
const isFirstVoyageOfYear = (
  voyages: VoyageDataType[],
  index: number
): boolean => {

  const currentYear = getVoyageYear(voyages[index]);

  if (!currentYear) {
    return false;
  }

  // Premier voyage de toute la liste
  if (index === 0) {
    return true;
  }

  const previousYear = getVoyageYear(voyages[index - 1]);

  // L'année change par rapport au voyage précédent
  return currentYear !== previousYear;
};


/*
 * Indique si le voyage est le dernier voyage de son année.
 */
const isLastVoyageOfYear = (
  voyages: VoyageDataType[],
  index: number
): boolean => {

  const currentYear = getVoyageYear(voyages[index]);

  if (!currentYear) {
    return false;
  }

  // Dernier voyage de toute la liste
  if (index === voyages.length - 1) {
    return true;
  }

  const nextYear = getVoyageYear(voyages[index + 1]);

  // L'année change sur le voyage suivant
  return currentYear !== nextYear;
};


  return (
    <div className="listingSection__wrap [ nc-box-has-hover ] [ nc-dark-box-bg-has-hover ]">

      {/* ===================================================== */}
      {/* HEADER                                                 */}
      {/* ===================================================== */}

      <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">

        <div>
          <h2 className="text-2xl font-semibold dark:text-neutral-300">
            {t('sesVoyagesPublics')}
          </h2>

          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            {voyages.length > 0
              ? t('infosMasquees')
              : t('aucunVoyagePublic')}
          </span>
        </div>


        {/* ================================================= */}
        {/* SWITCH TIMELINE / CARTES                           */}
        {/* ================================================= */}

        {voyages.length > 0 && (
          <div
            className="
              flex
              items-center
              self-start
              rounded-xl
              bg-neutral-100
              p-1
              dark:bg-neutral-800
            "
          >

            {/* TIMELINE */}
            <button
              type="button"
              onClick={() => setViewMode('timeline')}
              className={`
                flex
                items-center
                gap-2
                rounded-lg
                px-3
                py-2
                text-sm
                font-medium
                transition-all
                ${
                  viewMode === 'timeline'
                    ? 'bg-white text-purple-600 shadow-sm dark:bg-neutral-700 dark:text-purple-400'
                    : 'text-neutral-500 hover:text-neutral-700 dark:text-neutral-400 dark:hover:text-neutral-200'
                }
              `}
            >

              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.8}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8 6h12M8 12h12M8 18h12"
                />

                <circle
                  cx="4"
                  cy="6"
                  r="1"
                  fill="currentColor"
                />

                <circle
                  cx="4"
                  cy="12"
                  r="1"
                  fill="currentColor"
                />

                <circle
                  cx="4"
                  cy="18"
                  r="1"
                  fill="currentColor"
                />
              </svg>

              Chronologie

            </button>


            {/* CARTES */}
            <button
              type="button"
              onClick={() => setViewMode('cards')}
              className={`
                flex
                items-center
                gap-2
                rounded-lg
                px-3
                py-2
                text-sm
                font-medium
                transition-all
                ${
                  viewMode === 'cards'
                    ? 'bg-white text-purple-600 shadow-sm dark:bg-neutral-700 dark:text-purple-400'
                    : 'text-neutral-500 hover:text-neutral-700 dark:text-neutral-400 dark:hover:text-neutral-200'
                }
              `}
            >

              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.8}
              >
                <rect
                  x="3"
                  y="3"
                  width="7"
                  height="7"
                  rx="1"
                />

                <rect
                  x="14"
                  y="3"
                  width="7"
                  height="7"
                  rx="1"
                />

                <rect
                  x="3"
                  y="14"
                  width="7"
                  height="7"
                  rx="1"
                />

                <rect
                  x="14"
                  y="14"
                  width="7"
                  height="7"
                  rx="1"
                />
              </svg>

              Cartes

            </button>

          </div>
        )}

      </div>


      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>


      {/* ===================================================== */}
      {/* TIMELINE                                               */}
      {/* ===================================================== */}

      {viewMode === 'timeline' && voyages.length > 0 && (

        <div className="mt-8">

          {/*
           * Structure :
           *
           * année | point | carte
           *
           * La largeur maximale de la zone voyage est volontairement
           * limitée afin de ne pas avoir une carte qui parte trop loin
           * vers la droite.
           */}

          <div className="relative">

            {/* LIGNE VERTICALE */}


             <div
  className="
    absolute
    left-[45px]
    sm:left-[73px]
    md:left-[85px]
    top-4
    bottom-4
    w-[2px]
    bg-purple-200
    dark:bg-purple-900
  "
/>


            <div className="space-y-4">

              {voyages.map(
                (voyage: VoyageDataType, index: number) => {

                  const showYear = isFirstVoyageOfYear(
                    voyages,
                    index
                  );

                  const year = getVoyageYear(voyage);

                  return (

                    <div
                      key={voyage.id_voyage}
                      className="
                         relative
    flex
    w-full
    min-w-0
    items-start
    gap-1
    md:gap-4
                      "
                    >

                      {/* ===================================== */}
                      {/* ANNÉE                                  */}
                      {/* ===================================== */}

                      <div
                        className="
                          w-[32px]
    min-w-[32px]
    sm:w-[58px]
    sm:min-w-[58px]
    pt-[11px]
    sm:pt-[15px]
    text-right
                        "
                      >

                        {showYear && year && (
                          <span
                            className="
                              text-xs
                              sm:text-lg
                              font-semibold
                              text-purple-600
                              dark:text-purple-400
                            "
                          >
                            {year}
                          </span>
                        )}

                      </div>


                      {/* ===================================== */}
                      {/* POINT                                  */}
                      {/* ===================================== */}

                      <div
                        className="
                          relative
    z-10
    flex
    w-5
    min-w-5
    sm:w-6
    sm:min-w-6
    flex-shrink-0
    justify-center
    pt-4
                        "
                      >

                        <div
                          className="
                             h-4
    w-4
    sm:h-6
    sm:w-6
    rounded-full
    border-[3px]
    sm:border-4
    border-white
    bg-purple-600
    shadow-sm
    dark:border-neutral-900
                          "
                        />

                      </div>


                      {/* ===================================== */}
                      {/* CARTE                                   */}
                      {/* ===================================== */}

                     
                       <div
  className="
    min-w-0
    w-0
    flex-1
    lg:flex-none
    md:w-[90%]
    lg:w-[80%]
    xl:w-[66.666667%]
  "
>

                        <VoyageCard
                          layout="timeline"
                          voyageData={voyage}
                          voyageKey={voyage.id_voyage}
                          onMajLike={handleMajLike}
                          onMajDislike={handleMajDislike}
                        />

                      </div>

                    </div>

                  );
                }
              )}

            </div>

          </div>

        </div>

      )}


      {/* ===================================================== */}
      {/* ANCIEN AFFICHAGE EN CARTES                             */}
      {/* ===================================================== */}

      {viewMode === 'cards' && voyages.length > 0 && (

        <div className="mt-8">

          <div
            className="
              grid
              grid-cols-1
              gap-6
              sm:grid-cols-2
              md:gap-7
            "
          >

            {voyages.map(
              (voyage: VoyageDataType) => (

                <VoyageCard
                  key={voyage.id_voyage}
                  layout="card"
                  voyageData={voyage}
                  voyageKey={voyage.id_voyage}
                  onMajLike={handleMajLike}
                  onMajDislike={handleMajDislike}
                />

              )
            )}

          </div>

        </div>

      )}

    </div>
  );
};


  return (
    <div className={`nc-VoyageurPage ${className}`} data-nc-id="VoyageurPage">
      <Helmet>
        <title>Voyageur</title>
      </Helmet>
      <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
        <div className="block flex-grow mb-24 lg:mb-0">
          <div className="lg:sticky lg:top-24">{renderSidebar()}</div>
        </div>
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
          {renderSection1()}
        </div>
      </main>
    </div>
  );
};

export default VoyageurPage;
